<template>
    <div class="no-xhide">
        <div data-aos="fade-up">
            <v-card class="elevation-0 px-16 py-10 support-main-bg rounded-xl d-none d-md-block">
                <p class="white--text fs-50 font-weight-bold mb-6">Disclaimer</p>

            </v-card>
            <v-card class="elevation-0 px-6 px-sm-8 py-10 support-main-bg rounded-0 d-md-none">
                <p class="white--text fs-50 font-weight-bold mb-6">Disclaimer</p>

            </v-card>
        </div>
        <div class="px-6 px-sm-8 pa-md-8 py-8 mb-md-1 mx-md-1">
            <div class="px-md-2">
                <p class="mb-2 font-weight-light lh-24">
                    Investments in securities markets are subject to market risks. Read all the related documents
                    carefully before investing. Brokerage will not exceed SEBI’s prescribed limit. The securities quoted are exemplary and are not
                    recommendatory. 
                </p>
                <v-card style="width: 50%;background-color: red;" :class="$vuetify.breakpoint.smAndDown ? 'brk-scr-crd-dis-mob  cust-scroll price-card-sty elevation-0 rounded-xl my-6' : 'brk-scr-crd-dis cust-scroll price-card-sty elevation-0 rounded-xl my-6'" >
                    
                <v-simple-table >
                    <template v-slot:default>
                <tbody>
                    <tr
          v-for="item in detailszebu"
          :key="item.name"
          class="py-1"
          style="line-height: 1; height: 15px;">
          <td class="font-weight-bold text-uppercase py-1 px-2" style="padding: 2px 6px; border-right: 1px solid #ccc;">{{ item.name }}</td>
          <td class="py-1 px-2">{{ item.value }}</td>
        </tr>
                </tbody>
            </template>
        </v-simple-table></v-card>
                <!-- <p>
                    <span class="font-weight-bold">SEBI Registration No</span>: INZ000174634<br>
                    <span class="font-weight-bold">NSE member ID</span> : 13179<br>
                    <span class="font-weight-bold"> BSE member ID </span>: 6550<br>
                    <span class="font-weight-bold">MCX member ID </span>: 55730<br>
                    <span class="font-weight-bold">CDSL DP ID</span>: 12080400<br>
                    <span class="font-weight-bold">AMFI ARN</span>: 113118<br>
                    <span class="font-weight-bold">Research Analyst</span>: INH200006044<br>
                    <span class="font-weight-bold">Head Office</span> : No: 301, Burma Colony, 4th Main Road, Perungudi, Chennai - 600096.<br>
                    <span class="font-weight-bold">Registered Office Address</span>: No: 36, Ground Floor, Sri Krishna Complex, (opp to IDBI bank),
                    Sathy Road, Erode - 638 003.<br>
                    <span class="font-weight-bold">Investor grievance</span>: grievance@zebutrade.com<br>
                </p> -->
                <p class="mb-2 font-weight-light lh-24">
                    Zebu, a Stock Broker since 2013, is a financial services intermediary and does not offer tips,
                    advisory, solicitation, opinions, or portfolio management services in any manner. All content
                    shared, including on social media, is for educational or informational purposes only and not a
                    recommendation to invest or trade. Zebu is not liable for any investment or trading actions taken
                    based on such content. Please report any misuse or false representation of Zebu's name or services.
                    For queries, contact assist@zebuetrade.com
                </p>
                <p class="mb-2 font-weight-light lh-24">
                    Mutual Funds and Insurance are not Exchange traded products. Zebu is only acting as a distributor
                    for both.
                </p>
                <p class="mb-2 font-weight-light lh-24">
                    Customers need to check products & features before investing since the contours of the product rates
                    may change from time to time. Zebu Share and Wealth Managements Pvt Ltd is not liable for any loss or damage of any kind arising
                    out of investments in these products.
                </p>
                <p class="mb-2 font-weight-light lh-24">
                    Investments in Equity, Currency, Futures & Options and Commodities are subject to market risk. Clients should read the Risk Disclosure Document issued by SEBI & relevant exchanges & the T&C on
                    https://zebuetrade.com before investing.
                </p>
                <!-- <p class="mb-0 font-weight-light lh-28">
                    In case you have any grievances or suggestions, please write to <a  target="_blank" rel="noopener noreferrer"  class="mailto-txt"
                        href="mailto: grievance@zebuetrade.com">grievance@zebuetrade.com</a>.
                </p> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {

    data: () => ({

    detailszebu :[
        {"name" : "Name of the Member", "value" : "Zebu Share and Wealth Managements Pvt. Ltd."},
        {"name" : "SEBI Registration No", "value" : "INZ000174634"},
        {"name" : "NSE member ID", "value" : "13179"},
        {"name" : "BSE member ID", "value" : "6550"},
        {"name" : "MCX member ID ", "value" : "55730"},
        {"name" : "CDSL DP ID", "value" : "12080400"},
        {"name" : "AMFI ARN", "value" : "113118"},
        {"name" : "Head Office", "value" : "No: 301, Burma Colony, 4th Main Road, Perungudi, Chennai - 600096."},
        {"name" : "Registered Office Address", "value" : "No: 36, Ground Floor, Sri Krishna Complex, (opp to IDBI bank), Sathy Road, Erode - 638 003."},
        {"name" : "Investor grievance", "value" : "grievance@zebuetrade.com"},

    ]
    }),
}
</script>